import React, { useState, useEffect } from "react";
import { CustomisedTitle, TextWrapper, TextWrapperSpan, Wrapper } from "../../constants/common/StyledGlobalConstants";
import { Title } from "@vds/typography";
import Cards from "./Cards";
import { connect, useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions/contract/myContractDetailsActions";
import MyContractDetails from "./MyContractDetails";
import CPNotification from "../../pages/Login/CPNotification";
import { useNavigate } from "react-router-dom";
import * as account from "../../api/account/index";
import { useTranslation } from "react-i18next";
import SupportingUrl from "../../constants/SupportingUrl";
import UrlRedirection from "../common/UrlRedirection";
import { DEVICE_BREAKPOINTS, REDBALL_FEATURE_TOGGLE, suspendedFinancialStatuses } from "../../constants/appConstants";
import { chatDisplayHandler } from "../../util/chatBotUtils";

import { hasContractAccountDetails } from "../../util/util";
import { setHeaderAriaHidden } from "../../store/actions/global/global";
import PropTypes from "prop-types";
const { DESKTOP } = DEVICE_BREAKPOINTS;

const Contract = (props) => {
  const [showViewCase, setShowViewCase] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation("contractsTranslation");
  const dispatch = useDispatch();
  const {headerAriaHidden, accountUserTokenDetails} = useSelector((state) => state.ACCOUNT);
  useEffect(() => {
    if (props.title) {
      document.title = props.title;
    }
  }, [props.title]);

  const isNACOUNTRY = accountUserTokenDetails?.isNA;
  const isAPACCOUNTRY = accountUserTokenDetails?.isAPAC;
  const isEMEACOUNTRY = accountUserTokenDetails?.isEMEA;

  useEffect(() => {
    chatDisplayHandler(sessionStorage.getItem("currentPath"));
  }, []);
  // calling /acccounts api to fetch email and phone number
  useEffect(() => {
    window.scrollTo(0, 0);
    loadPrimaryAccountDetails();
  }, []);
  useEffect(() => {
    return () => {
      props.setCaseCreationSuccess(false);
    };
  }, []);

  const loadPrimaryAccountDetails = async () => {
    let responseArray = [];
    try {
      let reqBody = {
        accId: props.accountId,
      };
      responseArray = await account.getPrimaryAccountDetailsCall(reqBody);

      if (responseArray.data.statusCode === "200" && responseArray.data.data.length != 0) {
        responseArray = [...responseArray.data.data];
        props.setRequestContractDetails("accountPhoneNumber", responseArray[0].phone);
        props.setRequestContractDetails("accountEmailId", responseArray[0].email);
      }
    } catch (err) {
      console.log("error", err);
    }
    return responseArray;
  };

  /* START of REDBALL CONFIG */
  useEffect(() => {
    if (REDBALL_FEATURE_TOGGLE) {
      // Extract the contractAccountId from props.erpBusinessPartner by matching props.contractAccount
      const selectedContractAccount = props.erpBusinessPartner?.data?.contractAccountDetails?.find(
        (item) => item.erpCANumber === props.contractAccount
      );
      const contractAccountId = selectedContractAccount?.contractAccountId;

      // Get the paymentStatus for the selected contractAccountId from props.paymentStatus
      const selectedPaymentStatus = props.paymentStatus?.data?.find((item) => item.contractAccountId === contractAccountId)?.paymentStatus;

      const isSuspended =
        suspendedFinancialStatuses.includes(props.accountFinancialStatus?.toLowerCase()) &&
        hasContractAccountDetails(props.erpBusinessPartner, props.contractAccount);
      const isInRegion = isAPACCOUNTRY || isNACOUNTRY || isEMEACOUNTRY;

      // Set the banner status based on the selected paymentStatus
      if (isSuspended && selectedPaymentStatus !== "true" && isInRegion) {
        setShowViewCase(false);
      }
    }
  }, [props.paymentStatus, props.accountFinancialStatus, props.regionId, props.contractAccount, props.erpBusinessPartner]);
  /* END of REDBALL CONFIG */
  return (
    <div aria-hidden={headerAriaHidden}>
      <Wrapper marginBottom="4rem">
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1rem">
          <h1 className="sr-only">{t("Contracts and subscriptions")}</h1>
          <CustomisedTitle fontSize={"40px"} lineHeight="48px" aria-hidden="true">
            <Title size="large">
              {t("Contracts and subscriptions")}
            </Title>
          </CustomisedTitle>
          <Wrapper display="flex">
            <TextWrapper id="contract-info" fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" alignSelf="stretch">
              {t("For more information, see ")}
              <UrlRedirection
                label={t("FAQ: Contracts and cancellations")}
                link={SupportingUrl.FAQ_ContractsAndCancellation}
                ariaLabel={` ${t("FAQ: Contracts and cancellations")}`}
              />
              {"."}
            </TextWrapper>
          </Wrapper>
          <Wrapper width={"100%"} marginTop={props.caseCreationSuccess === true ? "2rem" : "0rem"}>
            <CPNotification
              isOpen={props.caseCreationSuccess}
              height="auto"
              width={props.windowSize.width >= DESKTOP ? "33.75rem" : "100%"}
              notificationType="success"
              closeButton={true}
              onClose={() => props.setCaseCreationSuccess(false)}
            >
              {" "}
              <TextWrapper id="notification-info" fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" alignSelf="stretch">
                {t("Your request has been submitted.")}
                {showViewCase && (
                  <>
                    &nbsp;
                    <TextWrapperSpan
                      aria-describedby="notification-info"
                      tabIndex="0"
                      aria-label={t("View here")}
                      color="#0077B4"
                      fontSize="0.875rem"
                      fontWeight="400"
                      lineHeight="1.25rem"
                      textDecorationLine="underline"
                      onClick={() => navigate(`/support/cases/caseList`)}
                      style={{ cursor: "pointer" }}
                    >
                      {t("View here")}
                    </TextWrapperSpan>
                    {"."}
                  </>
                )}
              </TextWrapper>{" "}
            </CPNotification>
          </Wrapper>
        </Wrapper>

        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" marginTop="3rem" gap="1rem">
          <Cards
            width={props.windowSize.width >= DESKTOP ? "33.75rem" : "100%"}
            title={t("Change my subscriptions")}
            subTitle={t("Remove subscriptions attached to your account.")}
            linkText={t("Request changes to subscriptions")}
            textId="change-my-services"
            onClickHandle={() => {
              props.toggleViewContractDetails(true);
              props.setContractDetailsType("change");
              dispatch(setHeaderAriaHidden(true))
            }}
          ></Cards>
          <Cards
            width={props.windowSize.width >= DESKTOP ? "33.75rem" : "100%"}
            title={t("Cancel my subscriptions")}
            subTitle={t("Cancel all subscriptions with Verizon Connect.")}
            linkText={t("Request to cancel all subscriptions")}
            textId="cancel-my-services"
            onClickHandle={() => {
              props.toggleViewContractDetails(true);
              props.setContractDetailsType("cancellation");
              dispatch(setHeaderAriaHidden(true))
            }}
          ></Cards>
        </Wrapper>
        {props.toggleViewContractDetails && <MyContractDetails contractDetailsType={props.contractDetailsType} />}
      </Wrapper>
    </div>
  );
};

const mapDispatchToProps = {
  toggleViewContractDetails: Actions.toggleViewContractDetails,
  setContractDetailsType: Actions.setContractDetailsType,
  setCaseCreationSuccess: Actions.setCaseCreationSuccess,
  setRequestContractDetails: Actions.setRequestContractDetails,
};
const mapStateToProps = (state) => {
  return {
    viewContractDetailsToggle: state.CONTRACT.viewContractDetailsToggle,
    windowSize: state.ACCOUNT.windowSize,
    contractDetailsType: state.CONTRACT.contractDetailsType,
    caseCreationSuccess: state.CONTRACT.caseCreationSuccess,
    accountId: state.ACCOUNT.account_id,
    userLanguage: state.ACCOUNT.userLanguage,
    erpBusinessPartner: state.ACCOUNT.erpBusinessPartner,
    contractAccount: state.BILLING.contractAccount,
  };
};

Contract.propTypes = {
  erpBusinessPartner: PropTypes.object,
  paymentStatus: PropTypes.object,
  accountFinancialStatus: PropTypes.string,
  regionId: PropTypes.string,
  contractAccount: PropTypes.string,
  setCaseCreationSuccess: PropTypes.func,
  setRequestContractDetails: PropTypes.func,
  accountId: PropTypes.string,
  title: PropTypes.string,
  windowSize: PropTypes.object,
  caseCreationSuccess: PropTypes.bool,
  toggleViewContractDetails: PropTypes.func,
  setContractDetailsType: PropTypes.func,
  contractDetailsType: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Contract);
